import { Stack, CircularProgress } from "@financeable-com-au/financeable-ui";

interface LoaderProps {
  text?: string;
  height?: string;
  size?: "sm" | "md" | "lg";
}

const Loader = ({ text, height = "100vh", size = "md" }: LoaderProps) => (
  <Stack alignItems="center" justifyContent="center" height={height} rowGap={2}>
    <CircularProgress size={size} />
    <span>{text ?? "Loading..."}</span>
  </Stack>
);

const MiniLoader = () => (
  <Stack direction="row" alignItems="center" justifyContent="center" height="100%" rowGap={2}>
    <CircularProgress size="md" />
  </Stack>
);

export { Loader, MiniLoader };
